webpackJsonp([82539731189068],{

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IconBase = function IconBase(_ref, _ref2) {
	  var children = _ref.children;
	  var color = _ref.color;
	  var size = _ref.size;
	  var style = _ref.style;
	  var width = _ref.width;
	  var height = _ref.height;
	
	  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'width', 'height']);
	
	  var _ref2$reactIconBase = _ref2.reactIconBase;
	  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;
	
	  var computedSize = size || reactIconBase.size || '1em';
	  return _react2.default.createElement('svg', _extends({
	    children: children,
	    fill: 'currentColor',
	    preserveAspectRatio: 'xMidYMid meet',
	    height: height || computedSize,
	    width: width || computedSize
	  }, reactIconBase, props, {
	    style: _extends({
	      verticalAlign: 'middle',
	      color: color || reactIconBase.color
	    }, reactIconBase.style || {}, style)
	  }));
	};
	
	IconBase.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  style: _propTypes2.default.object
	};
	
	IconBase.contextTypes = {
	  reactIconBase: _propTypes2.default.shape(IconBase.propTypes)
	};
	
	exports.default = IconBase;
	module.exports = exports['default'];

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdClose = function MdClose(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 10.7l-9.3 9.3 9.3 9.3-2.3 2.3-9.3-9.3-9.3 9.3-2.3-2.3 9.3-9.3-9.3-9.3 2.3-2.3 9.3 9.3 9.3-9.3z' })
	        )
	    );
	};
	
	exports.default = MdClose;
	module.exports = exports['default'];

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bodyOpenClassName = exports.portalClassName = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalPortal = __webpack_require__(103);
	
	var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
	
	var _ariaAppHider = __webpack_require__(45);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _safeHTMLElement = __webpack_require__(46);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var portalClassName = exports.portalClassName = "ReactModalPortal";
	var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
	
	var isReact16 = _reactDom2.default.createPortal !== undefined;
	var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
	      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
	      var parent = getParentElement(_this.props.parentSelector);
	      parent.removeChild(_this.node);
	    }, _this.portalRef = function (ref) {
	      _this.portal = ref;
	    }, _this.renderPortal = function (props) {
	      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
	      _this.portalRef(portal);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!_safeHTMLElement.canUseDOM) return;
	
	      if (!isReact16) {
	        this.node = document.createElement("div");
	      }
	      this.node.className = this.props.portalClassName;
	
	      var parent = getParentElement(this.props.parentSelector);
	      parent.appendChild(this.node);
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      var isOpen = newProps.isOpen;
	      // Stop unnecessary renders if modal is remaining closed
	
	      if (!this.props.isOpen && !isOpen) return;
	
	      var currentParent = getParentElement(this.props.parentSelector);
	      var newParent = getParentElement(newProps.parentSelector);
	
	      if (newParent !== currentParent) {
	        currentParent.removeChild(this.node);
	        newParent.appendChild(this.node);
	      }
	
	      !isReact16 && this.renderPortal(newProps);
	    }
	  }, {
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(newProps) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      if (newProps.portalClassName !== this.props.portalClassName) {
	        this.node.className = newProps.portalClassName;
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
	
	      var state = this.portal.state;
	      var now = Date.now();
	      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
	
	      if (closesAt) {
	        if (!state.beforeClose) {
	          this.portal.closeWithTimeout();
	        }
	
	        setTimeout(this.removePortal, closesAt - now);
	      } else {
	        this.removePortal();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!_safeHTMLElement.canUseDOM || !isReact16) {
	        return null;
	      }
	
	      if (!this.node && isReact16) {
	        this.node = document.createElement("div");
	      }
	
	      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
	        ref: this.portalRef,
	        defaultStyles: Modal.defaultStyles
	      }, this.props)), this.node);
	    }
	  }], [{
	    key: "setAppElement",
	    value: function setAppElement(element) {
	      ariaAppHider.setElement(element);
	    }
	
	    /* eslint-disable react/no-unused-prop-types */
	
	    /* eslint-enable react/no-unused-prop-types */
	
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  portalClassName: _propTypes2.default.string,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  ariaHideApp: _propTypes2.default.bool,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  parentSelector: _propTypes2.default.func,
	  aria: _propTypes2.default.object,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func
	};
	Modal.defaultProps = {
	  isOpen: false,
	  portalClassName: portalClassName,
	  bodyOpenClassName: bodyOpenClassName,
	  ariaHideApp: true,
	  closeTimeoutMS: 0,
	  shouldFocusAfterRender: true,
	  shouldCloseOnEsc: true,
	  shouldCloseOnOverlayClick: true,
	  shouldReturnFocusAfterClose: true,
	  parentSelector: function parentSelector() {
	    return document.body;
	  }
	};
	Modal.defaultStyles = {
	  overlay: {
	    position: "fixed",
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    backgroundColor: "rgba(255, 255, 255, 0.75)"
	  },
	  content: {
	    position: "absolute",
	    top: "40px",
	    left: "40px",
	    right: "40px",
	    bottom: "40px",
	    border: "1px solid #ccc",
	    background: "#fff",
	    overflow: "auto",
	    WebkitOverflowScrolling: "touch",
	    borderRadius: "4px",
	    outline: "none",
	    padding: "20px"
	  }
	};
	exports.default = Modal;

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _focusManager = __webpack_require__(105);
	
	var focusManager = _interopRequireWildcard(_focusManager);
	
	var _scopeTab = __webpack_require__(106);
	
	var _scopeTab2 = _interopRequireDefault(_scopeTab);
	
	var _ariaAppHider = __webpack_require__(45);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _classList = __webpack_require__(104);
	
	var classList = _interopRequireWildcard(_classList);
	
	var _safeHTMLElement = __webpack_require__(46);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: "ReactModal__Overlay",
	  content: "ReactModal__Content"
	};
	
	var TAB_KEY = 9;
	var ESC_KEY = 27;
	
	var ariaHiddenInstances = 0;
	
	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);
	
	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);
	
	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
	
	    _this.setFocusAfterRender = function (focus) {
	      _this.focusAfterRender = _this.props.shouldFocusAfterRender && focus;
	    };
	
	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	      _this.props.overlayRef && _this.props.overlayRef(overlay);
	    };
	
	    _this.setContentRef = function (content) {
	      _this.content = content;
	      _this.props.contentRef && _this.props.contentRef(content);
	    };
	
	    _this.afterClose = function () {
	      var _this$props = _this.props,
	          appElement = _this$props.appElement,
	          ariaHideApp = _this$props.ariaHideApp,
	          htmlOpenClassName = _this$props.htmlOpenClassName,
	          bodyOpenClassName = _this$props.bodyOpenClassName;
	
	      // Remove classes.
	
	      classList.remove(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      // Reset aria-hidden attribute if all modals have been removed
	      if (ariaHideApp && ariaHiddenInstances > 0) {
	        ariaHiddenInstances -= 1;
	
	        if (ariaHiddenInstances === 0) {
	          ariaAppHider.show(appElement);
	        }
	      }
	
	      if (_this.props.shouldFocusAfterRender) {
	        if (_this.props.shouldReturnFocusAfterClose) {
	          focusManager.returnFocus();
	          focusManager.teardownScopedFocus();
	        } else {
	          focusManager.popWithoutFocus();
	        }
	      }
	    };
	
	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        if (_this.props.shouldFocusAfterRender) {
	          focusManager.setupScopedFocus(_this.node);
	          focusManager.markForFocusLater();
	        }
	
	        _this.setState({ isOpen: true }, function () {
	          _this.setState({ afterOpen: true });
	
	          if (_this.props.isOpen && _this.props.onAfterOpen) {
	            _this.props.onAfterOpen();
	          }
	        });
	      }
	    };
	
	    _this.close = function () {
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };
	
	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus();
	    };
	
	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };
	
	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };
	
	    _this.handleKeyDown = function (event) {
	      if (event.keyCode === TAB_KEY) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }
	
	      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
	        event.stopPropagation();
	        _this.requestClose(event);
	      }
	    };
	
	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	      _this.moveFromContentToOverlay = null;
	    };
	
	    _this.handleOverlayOnMouseUp = function () {
	      if (_this.moveFromContentToOverlay === null) {
	        _this.shouldClose = false;
	      }
	      if (_this.props.shouldCloseOnOverlayClick) {
	        _this.shouldClose = true;
	      }
	    };
	
	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleOverlayOnMouseDown = function (event) {
	      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
	        event.preventDefault();
	      }
	      _this.moveFromContentToOverlay = false;
	    };
	
	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	      _this.moveFromContentToOverlay = false;
	    };
	
	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };
	
	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };
	
	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };
	
	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };
	
	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + "--after-open",
	        beforeClose: CLASS_NAMES[which] + "--before-close"
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + " " + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + " " + classNames.beforeClose;
	      }
	      return typeof additional === "string" && additional ? className + " " + additional : className;
	    };
	
	    _this.ariaAttributes = function (items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc["aria-" + name] = items[name];
	        return acc;
	      }, {});
	    };
	
	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };
	
	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }
	
	  _createClass(ModalPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Focus needs to be set when mounting and already open
	      if (this.props.isOpen) {
	        this.setFocusAfterRender(true);
	        this.open();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (false) {
	        if (newProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	        if (newProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	      }
	      // Focus only needs to be set once when the modal is being opened
	      if (!this.props.isOpen && newProps.isOpen) {
	        this.setFocusAfterRender(true);
	        this.open();
	      } else if (this.props.isOpen && !newProps.isOpen) {
	        this.close();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.focusAfterRender) {
	        this.focusContent();
	        this.setFocusAfterRender(false);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.afterClose();
	      clearTimeout(this.closeTimer);
	    }
	  }, {
	    key: "beforeOpen",
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          htmlOpenClassName = _props.htmlOpenClassName,
	          bodyOpenClassName = _props.bodyOpenClassName;
	
	      // Add classes.
	
	      classList.add(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      if (ariaHideApp) {
	        ariaHiddenInstances += 1;
	        ariaAppHider.hide(appElement);
	      }
	    }
	
	    // Don't steal focus from inner elements
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          overlayClassName = _props2.overlayClassName,
	          defaultStyles = _props2.defaultStyles;
	
	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
	
	      return this.shouldBeClosed() ? null : _react2.default.createElement(
	        "div",
	        {
	          ref: this.setOverlayRef,
	          className: this.buildClassName("overlay", overlayClassName),
	          style: _extends({}, overlayStyles, this.props.style.overlay),
	          onClick: this.handleOverlayOnClick,
	          onMouseDown: this.handleOverlayOnMouseDown,
	          onMouseUp: this.handleOverlayOnMouseUp,
	          "aria-modal": "true"
	        },
	        _react2.default.createElement(
	          "div",
	          _extends({
	            ref: this.setContentRef,
	            style: _extends({}, contentStyles, this.props.style.content),
	            className: this.buildClassName("content", className),
	            tabIndex: "-1",
	            onKeyDown: this.handleKeyDown,
	            onMouseDown: this.handleContentOnMouseDown,
	            onMouseUp: this.handleContentOnMouseUp,
	            onClick: this.handleContentOnClick,
	            role: this.props.role,
	            "aria-label": this.props.contentLabel
	          }, this.ariaAttributes(this.props.aria || {})),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return ModalPortal;
	}(_react.Component);
	
	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  }
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  defaultStyles: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  ariaHideApp: _propTypes2.default.bool,
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  aria: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func
	};
	exports.default = ModalPortal;
	module.exports = exports["default"];

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assertNodeList = assertNodeList;
	exports.setElement = setElement;
	exports.validateElement = validateElement;
	exports.hide = hide;
	exports.show = show;
	exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
	exports.resetForTesting = resetForTesting;
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalElement = null;
	
	function assertNodeList(nodeList, selector) {
	  if (!nodeList || !nodeList.length) {
	    throw new Error("react-modal: No elements were found for selector " + selector + ".");
	  }
	}
	
	function setElement(element) {
	  var useElement = element;
	  if (typeof useElement === "string") {
	    var el = document.querySelectorAll(useElement);
	    assertNodeList(el, useElement);
	    useElement = "length" in el ? el[0] : el;
	  }
	  globalElement = useElement || globalElement;
	  return globalElement;
	}
	
	function validateElement(appElement) {
	  if (!appElement && !globalElement) {
	    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
	
	    return false;
	  }
	
	  return true;
	}
	
	function hide(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).setAttribute("aria-hidden", "true");
	  }
	}
	
	function show(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).removeAttribute("aria-hidden");
	  }
	}
	
	function documentNotReadyOrSSRTesting() {
	  globalElement = null;
	}
	
	function resetForTesting() {
	  globalElement = null;
	}

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dumpClassLists = dumpClassLists;
	var htmlClassList = {};
	var docBodyClassList = {};
	
	function dumpClassLists() {
	  if (false) {
	    var classes = document.getElementsByTagName("html")[0].className;
	    var buffer = "Show tracked classes:\n\n";
	
	    buffer += "<html /> (" + classes + "):\n";
	    for (var x in htmlClassList) {
	      buffer += "  " + x + " " + htmlClassList[x] + "\n";
	    }
	
	    classes = document.body.className;
	
	    // eslint-disable-next-line max-len
	    buffer += "\n\ndoc.body (" + classes + "):\n";
	    for (var _x in docBodyClassList) {
	      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
	    }
	
	    buffer += "\n";
	
	    // eslint-disable-next-line no-console
	    console.log(buffer);
	  }
	}
	
	/**
	 * Track the number of reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var incrementReference = function incrementReference(poll, className) {
	  if (!poll[className]) {
	    poll[className] = 0;
	  }
	  poll[className] += 1;
	  return className;
	};
	
	/**
	 * Drop the reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var decrementReference = function decrementReference(poll, className) {
	  if (poll[className]) {
	    poll[className] -= 1;
	  }
	  return className;
	};
	
	/**
	 * Track a class and add to the given class list.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be tracked.
	 */
	var trackClass = function trackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    incrementReference(poll, className);
	    classListRef.add(className);
	  });
	};
	
	/**
	 * Untrack a class and remove from the given class list if the reference
	 * reaches 0.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be untracked.
	 */
	var untrackClass = function untrackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    decrementReference(poll, className);
	    poll[className] === 0 && classListRef.remove(className);
	  });
	};
	
	/**
	 * Public inferface to add classes to the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var add = exports.add = function add(element, classString) {
	  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};
	
	/**
	 * Public inferface to remove classes from the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var remove = exports.remove = function remove(element, classString) {
	  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleBlur = handleBlur;
	exports.handleFocus = handleFocus;
	exports.markForFocusLater = markForFocusLater;
	exports.returnFocus = returnFocus;
	exports.popWithoutFocus = popWithoutFocus;
	exports.setupScopedFocus = setupScopedFocus;
	exports.teardownScopedFocus = teardownScopedFocus;
	
	var _tabbable = __webpack_require__(47);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	function handleBlur() {
	  needToFocus = true;
	}
	
	function handleFocus() {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function () {
	      if (modalElement.contains(document.activeElement)) {
	        return;
	      }
	      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
	      el.focus();
	    }, 0);
	  }
	}
	
	function markForFocusLater() {
	  focusLaterElements.push(document.activeElement);
	}
	
	/* eslint-disable no-console */
	function returnFocus() {
	  var toFocus = null;
	  try {
	    if (focusLaterElements.length !== 0) {
	      toFocus = focusLaterElements.pop();
	      toFocus.focus();
	    }
	    return;
	  } catch (e) {
	    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
	  }
	}
	/* eslint-enable no-console */
	
	function popWithoutFocus() {
	  focusLaterElements.length > 0 && focusLaterElements.pop();
	}
	
	function setupScopedFocus(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener("blur", handleBlur, false);
	    document.addEventListener("focus", handleFocus, true);
	  } else {
	    window.attachEvent("onBlur", handleBlur);
	    document.attachEvent("onFocus", handleFocus);
	  }
	}
	
	function teardownScopedFocus() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener("blur", handleBlur);
	    document.removeEventListener("focus", handleFocus);
	  } else {
	    window.detachEvent("onBlur", handleBlur);
	    document.detachEvent("onFocus", handleFocus);
	  }
	}

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = undefined;
	
	var _exenv = __webpack_require__(54);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EE = _exenv2.default;
	
	var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
	
	var canUseDOM = exports.canUseDOM = EE.canUseDOM;
	
	exports.default = SafeHTMLElement;

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;
	
	var _tabbable = __webpack_require__(47);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);
	
	  if (!tabbable.length) {
	    // Do nothing, since there are no elements that can receive focus.
	    event.preventDefault();
	    return;
	  }
	
	  var shiftKey = event.shiftKey;
	  var head = tabbable[0];
	  var tail = tabbable[tabbable.length - 1];
	
	  // proceed with default browser behavior on tab.
	  // Focus on last element on shift + tab.
	  if (node === document.activeElement) {
	    if (!shiftKey) return;
	    target = tail;
	  }
	
	  var target;
	  if (tail === document.activeElement && !shiftKey) {
	    target = head;
	  }
	
	  if (head === document.activeElement && shiftKey) {
	    target = tail;
	  }
	
	  if (target) {
	    event.preventDefault();
	    target.focus();
	    return;
	  }
	
	  // Safari radio issue.
	  //
	  // Safari does not move the focus to the radio button,
	  // so we need to force it to really walk through all elements.
	  //
	  // This is very error prune, since we are trying to guess
	  // if it is a safari browser from the first occurence between
	  // chrome or safari.
	  //
	  // The chrome user agent contains the first ocurrence
	  // as the 'chrome/version' and later the 'safari/version'.
	  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
	  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
	
	  // If we are not in safari desktop, let the browser control
	  // the focus
	  if (!isSafariDesktop) return;
	
	  var x = tabbable.indexOf(document.activeElement);
	
	  if (x > -1) {
	    x += shiftKey ? -1 : 1;
	  }
	
	  event.preventDefault();
	
	  tabbable[x].focus();
	}
	module.exports = exports["default"];

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	var tabbableNode = /input|select|textarea|button|object/;
	
	function hidesContents(element) {
	  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
	
	  // If the node is empty, this is good enough
	  if (zeroSize && !element.innerHTML) return true;
	
	  // Otherwise we need to check some styles
	  var style = window.getComputedStyle(element);
	  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
	}
	
	function visible(element) {
	  var parentElement = element;
	  while (parentElement) {
	    if (parentElement === document.body) break;
	    if (hidesContents(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute("tabindex");
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
	}
	module.exports = exports["default"];

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(102);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/productInfoSide.25046ea9.jpg";

/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/productsBG.35de30b1.jpg";

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  position: relative;\n'], ['\n  display: flex;\n  position: relative;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: auto;\n  width: 75%;\n  background: #fff;\n  position: relative;\n  padding: 50px 0;\n  \n  @media (min-width: 768px) {\n   width: 100%;\n   max-width: 800px;\n  }\n  \n  h1 {\n    margin: 20px 0;\n  }\n  \n  svg {\n    position: absolute;\n    top: 1%;\n    right: 1%;\n    cursor: pointer;\n    font-size: 30px;\n    color: #909090\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: auto;\n  width: 75%;\n  background: #fff;\n  position: relative;\n  padding: 50px 0;\n  \n  @media (min-width: 768px) {\n   width: 100%;\n   max-width: 800px;\n  }\n  \n  h1 {\n    margin: 20px 0;\n  }\n  \n  svg {\n    position: absolute;\n    top: 1%;\n    right: 1%;\n    cursor: pointer;\n    font-size: 30px;\n    color: #909090\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 135px;\n  height: 135px;\n'], ['\n  width: 135px;\n  height: 135px;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  padding: 0 20px;\n  @media(min-width: 768px){\n    padding: 0 100px;\n  }\n'], ['\n  padding: 0 20px;\n  @media(min-width: 768px){\n    padding: 0 100px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(72);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Kit = __webpack_require__(6);
	
	var _close = __webpack_require__(101);
	
	var _close2 = _interopRequireDefault(_close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ContentContainer = _styledComponents2.default.div(_templateObject);
	
	var ValuesContainer = _styledComponents2.default.div(_templateObject2);
	
	var ValueImg = _styledComponents2.default.img(_templateObject3);
	
	var ValueText = _Kit.P2.extend(_templateObject4);
	
	var ValuesModal = function (_React$Component) {
	  _inherits(ValuesModal, _React$Component);
	
	  function ValuesModal() {
	    _classCallCheck(this, ValuesModal);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ValuesModal.prototype.render = function render() {
	    var _props = this.props,
	        isOpen = _props.isOpen,
	        close = _props.close,
	        _props$modalData = _props.modalData,
	        title = _props$modalData.title,
	        description = _props$modalData.description,
	        image = _props$modalData.image;
	
	    return _react2.default.createElement(
	      _reactModal2.default,
	      {
	        ariaHideApp: false,
	        isOpen: isOpen,
	        onRequestClose: function onRequestClose() {
	          return close();
	        },
	        style: {
	          overlay: {
	            position: 'fixed',
	            top: 0,
	            left: 0,
	            right: 0,
	            bottom: 0,
	            backgroundColor: 'rgba(0, 0, 0, 0.75)',
	            display: 'flex',
	            justifyContent: 'center',
	            alignItems: 'center'
	          },
	          content: {
	            position: 'relative',
	            border: 'none',
	            background: 'none',
	            padding: 0,
	            top: 0,
	            bottom: 0,
	            right: 0,
	            left: 0,
	            overflow: 'auto',
	            WebkitOverflowScrolling: 'touch'
	          }
	        },
	        contentLabel: 'Modal'
	      },
	      _react2.default.createElement(
	        ContentContainer,
	        null,
	        _react2.default.createElement(
	          ValuesContainer,
	          null,
	          _react2.default.createElement(ValueImg, {
	            src: image.source_url,
	            alt: image.alt_text
	          }),
	          _react2.default.createElement(
	            _Kit.ValueTitle,
	            null,
	            title
	          ),
	          _react2.default.createElement(ValueText, {
	            dangerouslySetInnerHTML: { __html: description }
	          }),
	          _react2.default.createElement(_close2.default, {
	            onClick: function onClick() {
	              return close();
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return ValuesModal;
	}(_react2.default.Component);
	
	exports.default = ValuesModal;
	module.exports = exports['default'];

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: left;\n'], ['\n  display: flex;\n  justify-content: left;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n'], ['\n  display: flex;\n  flex-direction: column;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-family: Cabin-Bold, sans-serif;\n  font-size: 18px;\n  color: #000;\n'], ['\n  font-family: Cabin-Bold, sans-serif;\n  font-size: 18px;\n  color: #000;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: flex;\n'], ['\n  display: flex;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  margin-top: 12px;\n  margin-right: 20px;\n\n  img {\n    margin-right: 10px;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  margin-top: 12px;\n  margin-right: 20px;\n\n  img {\n    margin-right: 10px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(10);
	
	var _freshIcon = __webpack_require__(157);
	
	var _freshIcon2 = _interopRequireDefault(_freshIcon);
	
	var _frozenIcon = __webpack_require__(158);
	
	var _frozenIcon2 = _interopRequireDefault(_frozenIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledBodyContainer = _Container.BodyContainer.extend(_templateObject);
	
	var LegendContainer = _styledComponents2.default.div(_templateObject2);
	
	var Title = _styledComponents2.default.p(_templateObject3);
	
	var GroupContainer = _styledComponents2.default.div(_templateObject4);
	
	var IconContainer = _styledComponents2.default.div(_templateObject5);
	
	var IconLegend = function IconLegend() {
	  return _react2.default.createElement(
	    StyledBodyContainer,
	    null,
	    _react2.default.createElement(
	      LegendContainer,
	      null,
	      _react2.default.createElement(
	        Title,
	        null,
	        'Icon Legend'
	      ),
	      _react2.default.createElement(
	        GroupContainer,
	        null,
	        _react2.default.createElement(
	          IconContainer,
	          null,
	          _react2.default.createElement('img', { src: _freshIcon2.default, alt: 'fresh icon' }),
	          _react2.default.createElement(
	            Title,
	            null,
	            'Fresh'
	          )
	        ),
	        _react2.default.createElement(
	          IconContainer,
	          null,
	          _react2.default.createElement('img', { src: _frozenIcon2.default, alt: 'frozen icon' }),
	          _react2.default.createElement(
	            Title,
	            null,
	            'Frozen'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IconLegend;
	module.exports = exports['default'];

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  margin-bottom: -32px;\n  @media(min-width: 768px) {\n      padding-bottom: 0;  \n      margin-bottom: -100px;\n   }\n  \n  @media(min-width: 992px) {\n      padding-bottom: 0;  \n  }\n  \n  @media(min-width: 1200px) {\n      padding-bottom: 0;  \n  }\n  \n  @media(min-width: 1680px) {\n      padding-bottom: 0;  \n  }\n"], ["\n  margin-bottom: -32px;\n  @media(min-width: 768px) {\n      padding-bottom: 0;  \n      margin-bottom: -100px;\n   }\n  \n  @media(min-width: 992px) {\n      padding-bottom: 0;  \n  }\n  \n  @media(min-width: 1200px) {\n      padding-bottom: 0;  \n  }\n  \n  @media(min-width: 1680px) {\n      padding-bottom: 0;  \n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(10);
	
	var _SingleProduct = __webpack_require__(383);
	
	var _SingleProduct2 = _interopRequireDefault(_SingleProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledBodyContainer = _Container.BodyContainer.extend(_templateObject);
	
	var ProductList = function ProductList(props) {
	    var data = props.data;
	
	    return _react2.default.createElement(
	        StyledBodyContainer,
	        null,
	        data.map(function (i, index) {
	            var _i$node = i.node,
	                _i$node$acf = _i$node.acf,
	                title = _i$node$acf.title,
	                short_description = _i$node$acf.short_description,
	                main_image = _i$node$acf.main_image,
	                fresh = _i$node$acf.fresh,
	                frozen = _i$node$acf.frozen,
	                slug = _i$node.slug;
	
	            return _react2.default.createElement(_SingleProduct2.default, {
	                key: title,
	                name: title,
	                fresh: fresh,
	                frozen: frozen,
	                summary: short_description,
	                img: main_image,
	                index: index,
	                slug: slug
	            });
	        })
	    );
	};
	
	exports.default = ProductList;
	module.exports = exports["default"];

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  @media(min-width: 992px){\n    padding: 0 130px;\n  }\n  \n  @media(min-width: 1200px){\n    padding: 0 220px;\n  }\n"], ["\n  @media(min-width: 992px){\n    padding: 0 130px;\n  }\n  \n  @media(min-width: 1200px){\n    padding: 0 220px;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  line-height: 1.25;\n  \n   @media(min-width: 992px){\n    padding: 0 50px;\n  }\n"], ["\n  line-height: 1.25;\n  \n   @media(min-width: 992px){\n    padding: 0 50px;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  margin-top: 30px;\n  display: flex;  \n  justify-content: space-around;\n  \n  @media(min-width: 1200px){\n    margin-top: 40px;\n  }\n"], ["\n  margin-top: 30px;\n  display: flex;  \n  justify-content: space-around;\n  \n  @media(min-width: 1200px){\n    margin-top: 40px;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  \n  p {\n    max-width: 135px;\n    cursor: pointer;\n  }\n  \n  img{\n    width: 80px;\n    height: 80px;\n    cursor: pointer;\n    \n    :hover {\n      filter: opacity(.6);\n    }\n    \n    @media(min-width: 992px) {\n      width: 100px;\n      height: 100px;\n    }\n    \n    @media(min-width: 1200px) {\n      width: 135px;\n      height: 135px;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  \n  p {\n    max-width: 135px;\n    cursor: pointer;\n  }\n  \n  img{\n    width: 80px;\n    height: 80px;\n    cursor: pointer;\n    \n    :hover {\n      filter: opacity(.6);\n    }\n    \n    @media(min-width: 992px) {\n      width: 100px;\n      height: 100px;\n    }\n    \n    @media(min-width: 1200px) {\n      width: 135px;\n      height: 135px;\n    }\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(10);
	
	var _Kit = __webpack_require__(6);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var InnerContainer = _styledComponents2.default.div(_templateObject);
	
	var Title = _Kit.CardTitle.extend(_templateObject2);
	
	var GroupContainer = _styledComponents2.default.div(_templateObject3);
	
	var CardContainer = _styledComponents2.default.div(_templateObject4);
	
	var QualitySection = function (_Component) {
	  _inherits(QualitySection, _Component);
	
	  function QualitySection() {
	    _classCallCheck(this, QualitySection);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  QualitySection.prototype.render = function render() {
	    var _props = this.props,
	        _onClick = _props.onClick,
	        subheader = _props.subheader,
	        data = _props.data;
	
	    return _react2.default.createElement(
	      _Container.BodyContainer,
	      null,
	      _react2.default.createElement(
	        Title,
	        null,
	        subheader
	      ),
	      _react2.default.createElement(
	        InnerContainer,
	        null,
	        _react2.default.createElement(
	          GroupContainer,
	          null,
	          data.map(function (i) {
	            return _react2.default.createElement(
	              CardContainer,
	              { key: i.title },
	              _react2.default.createElement("img", {
	                src: i.image.source_url,
	                alt: i.image.alt_text,
	                onClick: function onClick() {
	                  return _onClick(i.title);
	                }
	              }),
	              _react2.default.createElement(
	                _Kit.P2,
	                {
	                  onClick: function onClick() {
	                    return _onClick(i.title);
	                  }
	                },
	                i.title
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return QualitySection;
	}(_react.Component);
	
	exports.default = QualitySection;
	module.exports = exports["default"];

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-row-gap: 18px;\n  align-items: center;\n  \n  @media(min-width: 768px) {\n      grid-template-columns: 3fr 2fr;\n      grid-column-gap: 36px;\n  }\n  \n  img {\n    width: 100%;\n    \n    @media(min-width: 768px) {\n      order: 1;\n      align-self: start;\n    }\n  }\n'], ['\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-row-gap: 18px;\n  align-items: center;\n  \n  @media(min-width: 768px) {\n      grid-template-columns: 3fr 2fr;\n      grid-column-gap: 36px;\n  }\n  \n  img {\n    width: 100%;\n    \n    @media(min-width: 768px) {\n      order: 1;\n      align-self: start;\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  order: 2;\n  \n  @media(min-width: 768px) {\n    order: 1;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  order: 2;\n  \n  @media(min-width: 768px) {\n    order: 1;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  text-align: left;\n  \n  p{\n      p:first-of-type {\n          font-family: Cabin-Bold, sans-serif;\n          color: #004a87;\n          text-align: left;\n          \n          font-size: 14px;\n          line-height: 1.5;\n          z-index: 1;\n          \n          @media(min-width: 768px) {\n            font-size: 12px;\n          }\n          \n          @media(min-width: 992px) {\n            font-size: 14px;\n          }\n          \n           @media(min-width: 1200px) {\n            font-size: 16px;\n          }\n          \n           @media(min-width: 1680px) {\n            font-size: 25px;\n          }\n      }\n      \n      p{\n        text-align: left;\n        margin-bottom: 20px;\n         @media(min-width: 768px) {\n          margin-bottom: 40px;\n        }\n      }\n  }\n\n  + p {\n      p:first-of-type {\n              font-family: Cabin-Bold, sans-serif;\n              color: #004a87;\n              text-align: left;\n              \n              font-size: 14px;\n              line-height: 1.5;\n              z-index: 1;\n              \n              @media(min-width: 768px) {\n                font-size: 12px;\n              }\n              \n              @media(min-width: 992px) {\n                font-size: 14px;\n              }\n              \n               @media(min-width: 1200px) {\n                font-size: 16px;\n              }\n              \n               @media(min-width: 1680px) {\n                font-size: 25px;\n              }\n          }\n          \n          p{\n            text-align: left;\n            margin-bottom: 20px;\n             @media(min-width: 768px) {\n              margin-bottom: 40px;\n            }\n          }\n      }\n  }\n'], ['\n  text-align: left;\n  \n  p{\n      p:first-of-type {\n          font-family: Cabin-Bold, sans-serif;\n          color: #004a87;\n          text-align: left;\n          \n          font-size: 14px;\n          line-height: 1.5;\n          z-index: 1;\n          \n          @media(min-width: 768px) {\n            font-size: 12px;\n          }\n          \n          @media(min-width: 992px) {\n            font-size: 14px;\n          }\n          \n           @media(min-width: 1200px) {\n            font-size: 16px;\n          }\n          \n           @media(min-width: 1680px) {\n            font-size: 25px;\n          }\n      }\n      \n      p{\n        text-align: left;\n        margin-bottom: 20px;\n         @media(min-width: 768px) {\n          margin-bottom: 40px;\n        }\n      }\n  }\n\n  + p {\n      p:first-of-type {\n              font-family: Cabin-Bold, sans-serif;\n              color: #004a87;\n              text-align: left;\n              \n              font-size: 14px;\n              line-height: 1.5;\n              z-index: 1;\n              \n              @media(min-width: 768px) {\n                font-size: 12px;\n              }\n              \n              @media(min-width: 992px) {\n                font-size: 14px;\n              }\n              \n               @media(min-width: 1200px) {\n                font-size: 16px;\n              }\n              \n               @media(min-width: 1680px) {\n                font-size: 25px;\n              }\n          }\n          \n          p{\n            text-align: left;\n            margin-bottom: 20px;\n             @media(min-width: 768px) {\n              margin-bottom: 40px;\n            }\n          }\n      }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(10);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Kit = __webpack_require__(6);
	
	var _productInfoSide = __webpack_require__(849);
	
	var _productInfoSide2 = _interopRequireDefault(_productInfoSide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledBodyContainer = _Container.BodyContainer.extend(_templateObject);
	
	var TextContainer = _styledComponents2.default.div(_templateObject2);
	
	var Text = _styledComponents2.default.div(_templateObject3);
	
	var Section2 = function Section2(props) {
	  var content = props.content;
	
	  return _react2.default.createElement(
	    StyledBodyContainer,
	    null,
	    _react2.default.createElement(
	      TextContainer,
	      null,
	      _react2.default.createElement(
	        Text,
	        null,
	        _react2.default.createElement(_Kit.P2, {
	          dangerouslySetInnerHTML: { __html: content }
	        })
	      )
	    ),
	    _react2.default.createElement('img', { src: _productInfoSide2.default, alt: 'Wholesale Seafood Handler' })
	  );
	};
	
	exports.default = Section2;
	module.exports = exports['default'];

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-top: 50px;\n  display: grid;\n  grid-template-columns: 1fr;\n  align-items: center;\n  grid-column-gap: 24px;\n  position: relative;\n  margin-bottom: 32px;\n  grid-row-gap: 16px;\n  \n  @media(min-width: 768px) {\n    grid-template-columns: ', ';\n    padding-top: 100px;\n    margin-bottom: 100px;\n  }\n'], ['\n  padding-top: 50px;\n  display: grid;\n  grid-template-columns: 1fr;\n  align-items: center;\n  grid-column-gap: 24px;\n  position: relative;\n  margin-bottom: 32px;\n  grid-row-gap: 16px;\n  \n  @media(min-width: 768px) {\n    grid-template-columns: ', ';\n    padding-top: 100px;\n    margin-bottom: 100px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  order: 2;\n  z-index: 2;\n  \n  @media(min-width: 768px) {\n    order: 1;\n  }\n  \n  a {\n    margin-top: 30px;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  order: 2;\n  z-index: 2;\n  \n  @media(min-width: 768px) {\n    order: 1;\n  }\n  \n  a {\n    margin-top: 30px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin-right: 12px;\n  text-align: left;\n'], ['\n  margin-right: 12px;\n  text-align: left;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n'], ['\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  text-align: left;\n'], ['\n  text-align: left;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  margin-right: 10px;\n  display: ', '\n'], ['\n  margin-right: 10px;\n  display: ', '\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n\n'], ['\n\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  order: 1;\n  z-index: 2;\n  \n  @media(min-width: 768px) {\n    order: ', ';\n  }\n'], ['\n  width: 100%;\n  order: 1;\n  z-index: 2;\n  \n  @media(min-width: 768px) {\n    order: ', ';\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  display: none;\n  position: absolute;\n  top: 0;\n  color: #f6f6f6;\n  font-family: Cabin-Bold, sans-serif;\n  z-index: 1;\n  \n  @media(min-width: 768px) {\n    display: block;\n    font-size: 75px;\n  }\n  \n  @media(min-width: 992px) {\n    ', ';\n    font-size: 100px;\n  }\n  \n  @media(min-width: 1200px) {\n    font-size: 125px;\n  }\n  \n  @media(min-width: 1680px) {\n    font-size: 170px;\n  }\n  \n'], ['\n  display: none;\n  position: absolute;\n  top: 0;\n  color: #f6f6f6;\n  font-family: Cabin-Bold, sans-serif;\n  z-index: 1;\n  \n  @media(min-width: 768px) {\n    display: block;\n    font-size: 75px;\n  }\n  \n  @media(min-width: 992px) {\n    ', ';\n    font-size: 100px;\n  }\n  \n  @media(min-width: 1200px) {\n    font-size: 125px;\n  }\n  \n  @media(min-width: 1680px) {\n    font-size: 170px;\n  }\n  \n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Kit = __webpack_require__(6);
	
	var _frozenIcon = __webpack_require__(158);
	
	var _frozenIcon2 = _interopRequireDefault(_frozenIcon);
	
	var _freshIcon = __webpack_require__(157);
	
	var _freshIcon2 = _interopRequireDefault(_freshIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.leftImg ? '1fr 2fr' : '2fr 1fr';
	});
	
	var TextContainer = _styledComponents2.default.div(_templateObject2);
	
	var Name = _Kit.CardTitle.extend(_templateObject3);
	
	var NameContainer = _styledComponents2.default.div(_templateObject4);
	
	var Summary = _Kit.P2.extend(_templateObject5);
	
	var FreshIcon = _styledComponents2.default.img(_templateObject6, function (props) {
	  return props.render ? 'block' : 'none';
	});
	
	var FrozenIcon = FreshIcon.extend(_templateObject7);
	
	var ProductImg = _styledComponents2.default.img(_templateObject8, function (props) {
	  return props.leftImg ? '1' : '2';
	});
	
	var BackgroundText = _styledComponents2.default.div(_templateObject9, function (props) {
	  return props.leftImg ? 'left: 0' : 'right: 0';
	});
	
	var SingleProduct = function SingleProduct(props) {
	  var name = props.name,
	      fresh = props.fresh,
	      frozen = props.frozen,
	      summary = props.summary,
	      img = props.img,
	      slug = props.slug,
	      index = props.index;
	
	  var leftImg = index % 2 === 0;
	  if (!leftImg) {
	    return _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(
	        BackgroundText,
	        null,
	        name
	      ),
	      _react2.default.createElement(
	        TextContainer,
	        null,
	        _react2.default.createElement(
	          NameContainer,
	          null,
	          _react2.default.createElement(
	            Name,
	            null,
	            name
	          ),
	          _react2.default.createElement(FreshIcon, { src: _freshIcon2.default, render: fresh }),
	          _react2.default.createElement(FrozenIcon, { src: _frozenIcon2.default, render: frozen })
	        ),
	        _react2.default.createElement(Summary, {
	          dangerouslySetInnerHTML: { __html: summary }
	        }),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' + slug, title: 'Read More About ' + name },
	          _react2.default.createElement(
	            _Kit.OutlineButton,
	            null,
	            'Read More'
	          )
	        )
	      ),
	      _react2.default.createElement(ProductImg, { src: img.source_url, alt: img.alt_text })
	    );
	  }
	  return _react2.default.createElement(
	    Container,
	    { leftImg: leftImg },
	    _react2.default.createElement(
	      BackgroundText,
	      { leftImg: leftImg },
	      name
	    ),
	    _react2.default.createElement(ProductImg, { src: img.source_url, alt: img.alt_text, leftImg: leftImg }),
	    _react2.default.createElement(
	      TextContainer,
	      null,
	      _react2.default.createElement(
	        NameContainer,
	        null,
	        _react2.default.createElement(
	          Name,
	          null,
	          name
	        ),
	        _react2.default.createElement(FreshIcon, { src: _freshIcon2.default, render: fresh }),
	        _react2.default.createElement(FrozenIcon, { src: _frozenIcon2.default, render: frozen })
	      ),
	      _react2.default.createElement(Summary, {
	        dangerouslySetInnerHTML: { __html: summary }
	      }),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' + slug, title: 'Read More About ' + name },
	        _react2.default.createElement(
	          _Kit.OutlineButton,
	          null,
	          'Read More'
	        )
	      )
	    )
	  );
	};
	
	exports.default = SingleProduct;
	module.exports = exports['default'];

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.productInfoQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _productsBG = __webpack_require__(850);
	
	var _productsBG2 = _interopRequireDefault(_productsBG);
	
	var _Header = __webpack_require__(122);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _QualitySection = __webpack_require__(381);
	
	var _QualitySection2 = _interopRequireDefault(_QualitySection);
	
	var _Section = __webpack_require__(382);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _IconLegend = __webpack_require__(379);
	
	var _IconLegend2 = _interopRequireDefault(_IconLegend);
	
	var _ProductList = __webpack_require__(380);
	
	var _ProductList2 = _interopRequireDefault(_ProductList);
	
	var _ValuesModal = __webpack_require__(375);
	
	var _ValuesModal2 = _interopRequireDefault(_ValuesModal);
	
	var _hngutils = __webpack_require__(59);
	
	var _hngutils2 = _interopRequireDefault(_hngutils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductInfo = function (_Component) {
	    _inherits(ProductInfo, _Component);
	
	    function ProductInfo(props) {
	        _classCallCheck(this, ProductInfo);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	            valueModalOpen: false,
	            modalSelected: ""
	        };
	
	        _this.handleClick = function (title) {
	            _this.setState({
	                valueModalOpen: true,
	                modalSelected: title
	            });
	        };
	
	        _this.handleClose = function () {
	            _this.setState({
	                valueModalOpen: false
	            });
	        };
	
	        _this.props.data.modal.edges.forEach(function (edge) {
	            _hngutils2.default.imageSrcToLocalFile(edge.node.acf.image);
	        });
	
	        _this.props.data.product.edges.forEach(function (edge) {
	            _hngutils2.default.imageSrcToLocalFile(edge.node.acf.main_image);
	        });
	        return _this;
	    }
	
	    ProductInfo.prototype.render = function render() {
	        var _this2 = this;
	
	        var _state = this.state,
	            valueModalOpen = _state.valueModalOpen,
	            modalSelected = _state.modalSelected;
	        var _props$data = this.props.data,
	            allWordpressPage = _props$data.allWordpressPage,
	            modal = _props$data.modal,
	            product = _props$data.product;
	
	        var pageData = allWordpressPage.edges;
	        var modalData = modal.edges.map(function (i) {
	            var _i$node$acf = i.node.acf,
	                description = _i$node$acf.description,
	                image = _i$node$acf.image,
	                title = _i$node$acf.title;
	
	            return { description: description, image: image, title: title };
	        });
	        var selectedModal = modalData.filter(function (i) {
	            return i.title === modalSelected;
	        });
	        var productData = product.edges;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Header2.default, { bg: _productsBG2.default, title: pageData[0].node.acf.header }),
	            _react2.default.createElement(_QualitySection2.default, {
	                onClick: function onClick(title) {
	                    return _this2.handleClick(title);
	                },
	                subheader: pageData[0].node.acf.subheader,
	                data: modalData
	            }),
	            valueModalOpen && _react2.default.createElement(_ValuesModal2.default, {
	                isOpen: valueModalOpen,
	                close: function close() {
	                    return _this2.handleClose();
	                },
	                modalData: selectedModal[0]
	            }),
	            _react2.default.createElement(_Section2.default, { content: pageData[0].node.content }),
	            _react2.default.createElement(_IconLegend2.default, null),
	            _react2.default.createElement(_ProductList2.default, { data: productData })
	        );
	    };
	
	    return ProductInfo;
	}(_react.Component);
	
	exports.default = ProductInfo;
	var productInfoQuery = exports.productInfoQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-product-info-js-aca3176fdb780318566f.js